import { captureError } from '@/monitoring/sentry';
import { isClient } from '@/utils/ssrUtils';

const TP_SRC =
  'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
const TP_ID = 'tp-bootstrap';

export const loadTrustpilotScript = () => {
  if (!isClient()) {
    return false;
  }

  const existing = document.getElementById(TP_ID) as HTMLScriptElement | null;
  if (existing) {
    return false;
  }

  const s = document.createElement('script');
  s.id = TP_ID;
  s.src = TP_SRC;
  s.async = true;
  document.head.appendChild(s);

  return true;
};

// Needed for workaround: Trustpilot not re-rendering the widget on route change
export const forceWidgetReload = (el: HTMLDivElement) => {
  if (!isClient()) {
    return;
  }

  const tp = (window as any).Trustpilot;
  if (tp?.loadFromElement && el) {
    try {
      tp.loadFromElement(el, true);
    } catch {
      captureError('Error reloading Trustpilot widget');
    }
  }
};
